import { map } from 'lodash';
import moment from 'moment';

import { TState } from '../schedule';

export const useAddBreak = (state: TState, messageApi) => {
    const addBreakToEds = (dates) => {
        state.eds = map(state.eds, (item) => {
            if (!item.is_day_off) {
                const sortedBreaks = [...item.breaks, dates].sort((a, b) => {
                    if (a.start_break_time < b.start_break_time) return -1;
                    if (a.start_break_time > b.start_break_time) return 1;
                    return 0;
                });
                return {
                    ...item,
                    breaks: sortedBreaks,
                };
            }
            return item;
        });
    };

    const tryAddBreak = (index: number | null, dates: moment.Moment[]) => {
        let mainFrom = moment(
            index == null ? state.schedule.start_time : state.eds[index].start_time,
            'HH:mm'
        );
        let mainTo = moment(
            index == null ? state.schedule.end_time : state.eds[index].end_time,
            'HH:mm'
        );
        let targetFrom = moment(dates[0].clone());
        let targetTo = moment(dates[1].clone());

        // Нормализация
        if (mainTo.isSameOrBefore(mainFrom)) {
            mainTo.add(1, 'day');
            if (targetFrom.hours() < mainFrom.hours()) {
                targetFrom.add(1, 'day');
                targetTo.add(1, 'day');
            } else if (targetTo.isBefore(targetFrom)) {
                targetTo.add(1, 'day');
            }
        }

        if (!targetFrom.isBefore(targetTo)) {
            messageApi.error('Начало должно быть раньше конца');
            return;
        }

        if (targetTo.diff(targetFrom, 'seconds') < 599) {
            messageApi.info('Перерыв должен быть не менее 10 минут');
            return;
        }

        // Проверка, что в границах раб. дня
        if (
            targetFrom.isBetween(mainFrom, mainTo, null, '[]') &&
            targetTo.isBetween(mainFrom, mainTo, null, '[]')
        ) {
            // Проверка, что не пересекается с другими перерывами
            const compareTo = (index == null ? state.schedule.breaks : state.eds[index].breaks).map(
                (cti) => {
                    return {
                        start_break_time: moment(
                            moment().format('YYYY-MM-DD ') + cti.start_break_time,
                            'YYYY-MM-DD HH:mm'
                        ),
                        end_break_time: moment(
                            moment().format('YYYY-MM-DD ') + cti.end_break_time,
                            'YYYY-MM-DD HH:mm'
                        ),
                    };
                }
            );

            // Функция нормализация даты в формат HH:mm:ss
            const normalizeTime = (m: moment.Moment) => moment(m.format('HH:mm:ss'), 'HH:mm:ss');

            for (let i = 0; i < compareTo.length; i++) {
                let brFrom = moment(compareTo[i].start_break_time);
                let brTo = moment(compareTo[i].end_break_time);
                if (
                    normalizeTime(targetFrom).isBetween(brFrom, brTo, null, '[]') ||
                    normalizeTime(targetTo).isBetween(brFrom, brTo, null, '[]') ||
                    normalizeTime(brFrom).isBetween(targetFrom, targetTo, null, '[]') ||
                    normalizeTime(brTo).isBetween(targetFrom, targetTo, null, '[]')
                ) {
                    messageApi.error('Перерыв не может пересекаться с другими');
                    return;
                }
            }

            compareTo.push({
                start_break_time: targetFrom,
                end_break_time: targetTo,
            });

            let toSave = compareTo
                .sort((a, b) => +a.start_break_time - +b.start_break_time)
                .map((tsi) => {
                    return {
                        start_break_time: tsi.start_break_time.format('HH:mm'),
                        end_break_time: tsi.end_break_time.format('HH:mm'),
                    };
                });

            if (index == null) state.schedule.breaks = toSave;
            else {
                state.eds[index].breaks = toSave;
            }

            index == null &&
                addBreakToEds({
                    start_break_time: targetFrom.format('HH:mm'),
                    end_break_time: targetTo.format('HH:mm'),
                });
            messageApi.success('Перерыв добавлен');
            return;
        } else {
            messageApi.error('Перерыв должен быть внутри рабочего дня');
            return;
        }
    };

    return { tryAddBreak };
};
